export default "__VITE_ASSET__DeUVr571__"